import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Switch,
  Spin,
  Tooltip,
  Select,
  Card,
  Upload,
  message,
  Modal,
  InputNumber,
} from "antd";
import {
  QuestionCircleOutlined,
  SaveOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import CKEditor from "react-ckeditor-component";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const FormItemLabelWithTooltip = ({ label, tooltip }) => {
  return (
    <>
      {label}{" "}
      <Tooltip title={tooltip}>
        <QuestionCircleOutlined
          className="gx-text-blue"
          style={{ marginLeft: 5, fontSize: "120%" }}
        />
      </Tooltip>
    </>
  );
};

const TenantParameterUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editorContent, setEditorContent] = useState();

  const [form] = Form.useForm();
  const [file, setFile] = useState();

  const [modalVisible, setModalVisible] = useState(false);
  const [filePath, setFilePath] = useState("");
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });

  const [currencyRatesRequired, setCurrencyRatesRequired] = useState(false);
  const [exchangeHandle, setExchangeHandle] = useState("");
  const [currencyAmountForB2BChange, setCurrencyAmountForB2BChange] =
    useState(false);
  const [isUseB2BCurrencyExChange, setIsUseB2BCurrencyExChange] =
    useState(false);

  const erpDesciptionOptions = [
    {
      value: 0,
      text: "Banka Açıklaması",
    },
    {
      value: 1,
      text: "Erp Açıklaması",
    },
  ];

  const changeAccessSwitch = (value, event) => {
    if (value) {
      if (event === "mailActive") {
        form.setFieldsValue({ tenantIsSmsAccess: false });
      }

      if (event === "smsActive") {
        form.setFieldsValue({ tenantIsMailAccess: false });
      }
    }
  };

  useEffect(() => {
    if (props.data) {
      if (props.data.posCollectionDescription) {
        setEditorContent(props.data.posCollectionDescription);
      }
      form.setFieldsValue(props.data);
      setCurrencyAmountForB2BChange(props.data.isHasSendCurrencyAmountForB2B);
      if (props.data.usdAmount == false && props.data.eurAmount == false)
        props.data.usdAmount = true;
      setExchangeHandle(props.data.usdAmount == true ? "USD" : "");
      if (props.data.b2BFilePath) {
        const img = new Image();
        img.src = props.data.b2BFilePath;
        img.onload = () => {
          setImageDimensions({ width: img.width, height: img.height });
        };
      }
      if (props.data.useB2BCustomCurrencyExChangeRate) {
        setCurrencyRatesRequired(true);
      }
      if (props.data.isUseB2BCurrencyExChange) {
        setIsUseB2BCurrencyExChange(true);
      }
    }
  }, [props.data]);

  const fileProps = (propertyName) => ({
    beforeUpload: (file, info) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("Yalnızca JPEG/PNG dosyaları yükleyebilirsiniz!");
        return false;
      }
      setFile(file);
      return false;
    },
    maxCount: 1,
    onChange: (info) => {
      if (info.fileList.length > 1) {
        message.error("Yalnızca bir dosya yükleyebilirsiniz!");
      } else if (info.fileList.length !== 0) {
        let bodyFormData = new FormData();
        bodyFormData.append("image", info.file); // 🟢 Dosyayı ekle

        RequestHandler.post(
          `/TenantParameter/AddB2BFile?propertyName=${encodeURIComponent(
            propertyName
          )}`, // 🟢 QueryString ekledik
          bodyFormData,
          false,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "bearer " + RequestHandler.getToken(),
            },
          }
        ).then((res) => {
          if (res.success) {
            window.location.reload();
          }
        });
      }
    },
  });

  const onFinish = (values) => {
    values.posCollectionDescription = editorContent;
    if (values.isHasSendCurrencyAmountForB2B == false) {
      values.usdAmount = false;
      values.eurAmount = false;
    } else {
      if (exchangeHandle == "USD") {
        values.usdAmount = true;
        values.eurAmount = false;
      } else {
        values.usdAmount = false;
        values.eurAmount = true;
      }
    }
    RequestHandler.put("/TenantParameter/UpdateParameters", values).then(
      (response) => {
        setLoading(false);
        if (response.success) {
          form.resetFields();
          if (props.onSuccess) props.onSuccess();
        }
      }
    );
  };
  const onFinishFailed = () => setLoading(false);

  const handleCancel = () => {
    URL.revokeObjectURL(filePath);
    setModalVisible(false);
  };

  const onFormValuesChange = (changedValues, allValues) => {
    if (allValues.useB2BCustomCurrencyExChangeRate === true) {
      setCurrencyRatesRequired(true);
    } else {
      setCurrencyRatesRequired(false);
    }
  };

  const setImageDimensionsAndFilePath = (filepath) => {
    setFilePath(filepath);
    if (filepath) {
      const img = new Image();
      img.src = filepath;
      img.onload = () => {
        setImageDimensions({ width: img.width, height: img.height });
      };
    }
  };

  return (
    <Spin spinning={props.loading}>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="TenantParameterUpdate"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onFormValuesChange}
      >
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>

        <Row justify="center">
          <Col xs={24} sm={12}>
            <Card
              title="Genel"
              style={{ margin: "10px 0", height: "90%" }}
              className="gx-card"
            >
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Sms Onayı Şifresiz/Şifreli"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar giriş yaparken tek kullanımlık sms
                              kod kullanır.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar giriş yaparken tek kullanımlık sms
                              kod kullanmadan devam eder.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="tenantIsSmsAccess"
                valuePropName="checked"
              >
                <Switch
                  onChange={(value) => {
                    changeAccessSwitch(value, "smsActive");
                  }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Mail Onayı Şifresiz/Şifreli"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar giriş yaparken tek kullanımlık mail
                              ile gelen kod kullanır.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar giriş yaparken tek kullanımlık mail
                              kod kullanmadan devam eder.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="tenantIsMailAccess"
                valuePropName="checked"
              >
                <Switch
                  onChange={(value) => {
                    changeAccessSwitch(value, "mailActive");
                  }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Rapor Döviz Kuru Günlük/Anlık"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Raporlamalarda anlık kur bilgisi kullanılır.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Raporlamalarda günlük kur bilgisi kullanılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isLiveValue"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Döviz Kuru Satış/Alış"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>Hesaplamalarda alış kur bilgisi kullanılır.</li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Hesaplamalarda satış kur bilgisi kullanılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isBuyingOrSellerValue"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              title="Hesap Hareketleri"
              style={{ margin: "10px 0", height: "90%" }}
              className="gx-card"
            >
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketleri Excel (B,A)/(+,-)"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Hesap Hareketlerinden alınan Excel Tutar alanı
                              '+/-' oluşturulur.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Hesap Hareketlerinden alınan Excel Tutar alanı her
                              zaman pozitif değer döner ve yanında bir alan ile
                              B/A ayrımı yapılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="transactionExcelType"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketleri Excel İşlem Tarihi Formatı"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar hesap hareketi exceli indirirken
                              İşlem Tarihi bilgisi Tarih ve Saat olarak 2 ayrı
                              sütunda indirilir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar hesap hareketi exceli indirirken
                              İşlem Tarihi bilgisi tek sütunda indirilir.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isTransactionDateSeperateInExcel"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketi Bildirimi"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar son 5 dakika içerisinde gelen hesap
                              hareketi kayıtları için bildirim alırlar.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isHasTransactionNotification"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Raporlara Virman İşlemleri Dahil Etme"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Rapor ekranlarında virman işlemleri dahil edilmez.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isNotUsingVirman"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketleri Saat Filtresi"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Hesap Hareketleri ekranında Tarih filtresi ile
                              birlikte saatleri de filtreye dahil edebilirsiniz.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isTransactionTimeFilter"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketleri Excel TL Döviz Cinsi Formatı"
                    tooltip={
                      <>
                        <p>
                          <ul>
                            <li>
                              Hesap Hareketleri Excel Sayfasından alınan
                              Excel'lerde TL Döviz cinsinin formatı seçilen
                              formata göre (TRY / TL) oluşturulur.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="transactionExcelCurrencyFormat"
              >
                <Select defaultValue={0} style={{ maxWidth: "30%" }}>
                  <Select.Option key={0} value={0}>
                    TRY
                  </Select.Option>
                  <Select.Option key={1} value={1}>
                    TL
                  </Select.Option>
                </Select>
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              title="B2B"
              style={{ margin: "10px 0", height: "95%" }}
              className="gx-card"
            >
              {/* {!props.data.isNKolay && (
                <Form.Item
                  label={
                    <FormItemLabelWithTooltip
                      label="Pos Komisyonu Bayiye Yansıtma/Yansıt"
                      tooltip={
                        <>
                          <p>
                            <strong>Seçenek aktif edilirse:</strong>
                            <ul>
                              <li>Komisyonlar aşağıdaki gibi hesaplanır.</li>
                              <li>
                                (GirilenTutar/(100-KomisyonOranı))*100
                                =ToplamTutar
                              </li>
                              <li>Örn : (1000/(100-2.5))*100 = 1025,64</li>
                            </ul>
                          </p>
                          <p>
                            <strong>Pasif edilirse:</strong>
                            <ul>
                              <li>Komisyonlar aşağıdaki gibi hesaplanır.</li>
                              <li>
                                GirilenTutar+(GirilenTutar/100)*KomisyonOranı=ToplamTutar
                              </li>
                              <li>Örn : 1000+(1000/100)*2.5 = 1025,00</li>
                            </ul>
                          </p>
                        </>
                      }
                    />
                  }
                  name="isPosCollectionCommissionFromDealer"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              )} */}
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Pos Tahsilat Komisyon Tablosunu Kullanma/Kullan"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Komisyon tanımları taksit tablosunda vade farkı
                              gibi yansıtılır.
                            </li>
                            <li>
                              Komisyon tanımı girilmeyen kuruluşlar için ödeme
                              yapılamaz.
                            </li>
                            <li>
                              Komisyon tanımı girişi yapılan taksit sayıları
                              için ödeme yapılabilir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Bayi yalnız girişi yapılan tutarı öder. Vade farkı
                              yansıtılmaz.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="useCommissionTableForAvailableInstallment"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Banka ve Taksit Birlikte Seçme/Seç"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Bayi, banka ve taksit sayısını tek seferde seçerek
                              ödemeyi tamamlar.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Bayi taksit tablosunu görür bankayı ve taksit
                              sayısını ayrı ayrı seçerek ödemeyi tamamlar.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isSelectableInstallmentTable"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Pos Tahsilat Ekranı Açıklama"
                    tooltip={
                      <>
                        <p>
                          <strong>Açıklama girilirse:</strong>
                          <ul>
                            <li>
                              Ödeme formu üst kısmında girilen açıklama
                              gösterilir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Açıklama girilmezse:</strong>
                          <ul>
                            <li>Herhangi bir açıklama gösterilmez.</li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="posCollectionDescription"
                getValueFromEvent={(_, editor) => editor.getData()}
              >
                <CKEditor
                  content={editorContent}
                  events={{
                    change: (e) => setEditorContent(e.editor.getData()),
                  }}
                  config={{
                    toolbarGroups: [
                      { name: "styles", groups: ["styles"] },
                      { name: "colors", groups: ["colors"] },
                      {
                        name: "basicstyles",
                        groups: ["basicstyles", "cleanup"],
                      },
                      "/",
                      {
                        name: "paragraph",
                        groups: [
                          "list",
                          "indent",
                          "blocks",
                          "align",
                          "bidi",
                          "paragraph",
                        ],
                      },
                      { name: "links", groups: ["links"] },
                      "/",
                    ],
                    removeButtons:
                      "Save,NewPage,Preview,Print,Templates,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Flash,Image,About,Strike,Subscript,Superscript,CopyFormatting,RemoveFormat,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Source,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,Styles,FontSize,Font,CreateDiv,Blockquote,Language,BidiRtl,BidiLtr,Anchor",
                  }}
                />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Linkle Ödeme Varsayılan Dil Seçeneği"
                    tooltip={
                      <>
                        <p>
                          <ul>
                            <li>
                              Linkle ödeme sayfası için varsayılan dil
                              seçeneğini belirleyebilirsiniz.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="b2BPayWithLinkDefaultLanguageOption"
              >
                <Select defaultValue={0} style={{ maxWidth: "30%" }}>
                  <Select.Option key={0} value={0}>
                    Türkçe
                  </Select.Option>
                  <Select.Option key={1} value={1}>
                    İngilizce
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Param Dekont'u Finekra'dan al"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Sanal Pos Param işlemlerinin dekontunu Koletra
                              dekontu olarak alabilirsiniz.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Sanal Pos Param işlemlerinin dekontu Param
                              tarafından maile gönderilir.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="paramReceiptPdfEnabled"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Pos Tahsilat Ekranı Dosya Ekle"
                    tooltip={
                      <>
                        <p>
                          <strong>PNG,JPEG formatında dosya eklenirse:</strong>
                          <ul>
                            <li>
                              Kullanıcı tahsilat ekranında butona tıklayarak,
                              eklenen dosyayı görüntüleyebilir.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Upload {...fileProps("B2BFilePath")}>
                    <Button icon={<UploadOutlined />}>Dosya Ekle</Button>
                  </Upload>
                  <Button
                    onClick={() => {
                      setImageDimensionsAndFilePath(props?.data?.b2BFilePath);
                      setModalVisible(true);
                    }}
                    style={{ marginLeft: 10 }}
                    hidden={props?.data?.B2BFilePath === null} // İstenirse butonlar arasına boşluk ekleyebilirsiniz
                  >
                    Dosyayı Göster
                  </Button>
                </div>
              </Form.Item>
              {isUseB2BCurrencyExChange && (
                <Form.Item
                  label={
                    <FormItemLabelWithTooltip
                      label="Döviz Karşılığı Gösterim Tipi"
                      tooltip={
                        <>
                          <p>
                            <strong>Seçenek aktif edilirse:</strong>
                            <ul>
                              <li>
                                Sanal Pos işlemlerinde döviz cinsi tutarları
                                için USD ve EURO kur oranları girilir.
                              </li>
                            </ul>
                          </p>
                          <p>
                            <strong>Pasif edilirse:</strong>
                            <ul>
                              <li>
                                Sanal Pos işlemlerinde döviz cinsi tutarları
                                için USD ve EURO kur oranları Merkez Bankası
                                günlük satış kuru baz alınır.
                              </li>
                            </ul>
                          </p>
                        </>
                      }
                    />
                  }
                  name="useB2BCustomCurrencyExChangeRate"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              )}
              {isUseB2BCurrencyExChange && (
                <Form.Item label="USD Döviz Kuru" name="b2BUsdExChangeRate">
                  <InputNumber
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    precision={2}
                    min={0}
                    placeholder="0,00"
                  />
                </Form.Item>
              )}
              {isUseB2BCurrencyExChange && (
                <Form.Item
                  label="Euro Döviz Kuru"
                  name="b2BEuroExChangeRate"
                  // rules={[{ required: currencyRatesRequired }]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    precision={2}
                    min={0}
                    placeholder="0,00"
                  />
                </Form.Item>
              )}

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Döviz Kurları Gösterimi"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Sanal Pos işlemlerinde döviz kurlarını
                              görebilirsiniz.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="b2BViewCurrencyExchangeRate"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="B2B Panel Giriş Ekranı Görseli Ekle"
                    tooltip={
                      <>
                        <p>
                          <strong>PNG,JPEG formatında görsel eklenirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar B2B panel sayfanızın giriş ekranını,
                              eklediğiniz görsel ile özelleştirilmiş şekilde
                              görüntüleyecektir. Önerilen görsel boyutu 640x890
                              boyutlarıdır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Upload {...fileProps("B2BPanelLoginBannerImagePath")}>
                    <Button icon={<UploadOutlined />}>Görsel Ekle</Button>
                  </Upload>
                  <Button
                    onClick={() => {
                      setImageDimensionsAndFilePath(
                        props?.data?.b2BPanelLoginBannerImagePath
                      );
                      setModalVisible(true);
                    }}
                    style={{ marginLeft: 10 }}
                    hidden={props?.data?.b2BPanelLoginBannerImagePath === null}
                  >
                    Görseli Göster
                  </Button>
                </div>
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="B2B Panel Giriş Ekranı Görsel Url'i Ekle"
                    tooltip={
                      <>
                        <p>
                          <strong>Url girilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar B2B panel sayfanızın giriş
                              ekranındaki görsel'e tıkladığı zaman bu url'e
                              yönlendirilir.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="b2BPanelLoginBannerImageUrl"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Tamamlanmayan İşlemlerin Bildirim Maillerini Al"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Sanal Pos işlemlerinde, yarıda kesilen,
                              tamamlanmayan işlemler için, ilgili Pos Tahsilat
                              erişiminde ekli olan Ödeme Bildirim E-postalarına
                              mail atılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="b2BNotCompletedTransactionNotify"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Başarısız İşlemlerin Bildirim Maillerini Al"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Sanal Pos işlemlerinde, başarısız olan işlemler
                              için, ilgili pos tahsilat erişiminde ekli olan
                              Ödeme Bildirim E-postalarına, işlem dekontuyla
                              beraber mail atılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isUseB2BUnsuccessfulTransactionReceipt"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Komisyon Oranı Bilgisini Gizle"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Tahsilat dekontlarında ve B2B Panel Tahsilat
                              Geçmişi ekranında, işlemde uygulanan komisyon
                              oranı müşteriye gösterilmez.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="b2BHideCommissionRateInfoOnReceipt"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

                    <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Dekont'da Kart Sahibi Adını Maskele"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Tahsilat dekontlarında kart sahibi adı
                              maskelenir.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isUseB2BReceiptMaskHolderName"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <br></br>
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              title="ERP"
              style={{ margin: "10px 0", height: "95%" }}
              className="gx-card"
            >
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Erp Aktarım sonrası Kural Ekleme"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Erp'ye Aktar butonuna basılıp İşlem Başarılı
                              olduğunda, sistem otomatik olarak eklenebilecek
                              kuralları listeler.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="useMultipleRuleAddOnErp"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Cari Vkn Adet Bilgisi"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              ERP Aktarım ekranında Cari Vkn Adet bilgisi
                              görüntülenir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Seçenek Pasif edilirse:</strong>
                          <ul>
                            <li>
                              ERP Aktarım ekranında Cari Vkn Adet bilgisi
                              görüntülenmez.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isUseFirmVknCount"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item label="Satır Açıklaması" name="erpLineDescription">
                <Select defaultValue={0} style={{ maxWidth: "60%" }}>
                  <Select.Option value={null}>Seçiniz</Select.Option>
                  {erpDesciptionOptions.map((x) => (
                    <Select.Option key={x.value} value={x.value}>
                      {x.text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="Fiş Açıklaması" name="erpReceiptDescription">
                <Select defaultValue={0} style={{ maxWidth: "60%" }}>
                  <Select.Option value={null}>Seçiniz</Select.Option>
                  {erpDesciptionOptions.map((x) => (
                    <Select.Option key={x.value} value={x.value}>
                      {x.text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Pos Tahsilat aktarımında döviz tutarı gönderilsin mi?"
                name="isHasSendCurrencyAmountForB2B"
                valuePropName="checked"
              >
                <Switch
                  onChange={(checked) => {
                    setCurrencyAmountForB2BChange(checked);
                  }}
                />
              </Form.Item>

              {currencyAmountForB2BChange && (
                <Form.Item label="USD / EUR ?">
                  <Switch
                    checked={exchangeHandle === "USD"}
                    checkedChildren="USD"
                    unCheckedChildren="EUR"
                    onChange={(checked) => {
                      setExchangeHandle(checked ? "USD" : "EUR");
                    }}
                    style={{ backgroundColor: "#0047CA" }}
                  />
                </Form.Item>
              )}
            </Card>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Col style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Kaydet
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
      <Modal
        visible={modalVisible}
        onCancel={handleCancel}
        footer={null}
        style={{ maxWidth: "100%" }}
        width={imageDimensions.width}
        bodyStyle={{ maxHeight: imageDimensions.height }}
      >
        {filePath && (
          <img
            src={filePath}
            alt="Dosya Resmi"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        )}
      </Modal>
    </Spin>
  );
};
export default TenantParameterUpdateForm;
